import types from '@/store/mutationTypes';
import { getConfigService, busService, initGoogleAnalytics, setHtmlTitle } from '@/utility';
import gamesStatic from '@nsftx/games-sdk-js/src/api/gamesStatic';
import createTranslationsProxy from '@nsftx/games-sdk-js/src/utility/translationsProxy';
import {assign} from 'lodash';
import rgsInit from './rgsInit';

function isiOSOperatingSystem() {
  const userAgent = navigator.userAgent;

  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}
const updateHeight = (store, isGame) => {
  if (
    (!store.getters.isDesktop && isGame) ||
    store.getters.layoutTerminal ||
    (!store.getters.isIntegration && isGame)
  ) {
    document.getElementsByTagName('html')[0].style.height = '100%'
    document.getElementsByTagName('body')[0].style.height = '100%'
    document.getElementById('app').style.height = '100%'
  }
}
const init = async (store) => {
  const params = store.getters.queryParametars;
  const iosApp = params.get('application') === 'mobile' && isiOSOperatingSystem();
  store.commit(types.SET_IOS_APP, iosApp);
  let isReady;
  const { pathname } = window.location;
  const isGame = pathname === '/';
  updateHeight(store, isGame);
  try {
    const config = await getConfigService(store);

    console.log('config', config);

    setHtmlTitle(config.applicationName);
    initGoogleAnalytics(config);

    if (store.getters.layoutTerminal) {
      if (store.state.gatewayConfigurationDetails?.deviceId && !config.deviceId) {
        config.deviceId = store.state.gatewayConfigurationDetails.deviceId;
      }
      if (store.state.gatewayConfigurationDetails?.productId && !config.productId) {
        config.productId = store.state.gatewayConfigurationDetails.productId;
      }
    }
    await store.commit(types.SET_CONFIG, config);

    await store.commit(types.SET_OFFER, config.state.eventsOffer);
    const paymentChips = config.ui?.config?.paymentChips;
    if (store.state.usePackageTranslations) {
      // NPM PACKED TRANS
      const translationsPackage = await import('@nsftx/i18n-virtual-soccer');
      const translations = await translationsPackage.exportTranslations(config?.locale || 'en', {
        companyName: config.tenantName || config.rawData?.companyInfo?.name || '',
        companyUuid: config.tenantId,
        env: config.environment,
      });
      const proxyTranslations = createTranslationsProxy(translations);
      await store.dispatch('setTranslations', proxyTranslations);
    } else {
      // STANDARD STATIC+LOCAL TRANS
      const staticTranslations = await gamesStatic.getTranslations(config?.locale || 'en');
      const { default: i18n } = await import('../i18n');
      const localTranslations = (await i18n(config?.locale || 'en')).default;
      await store.dispatch('setTranslations', assign(staticTranslations, localTranslations));
    }
    window.busService = await busService(config, store);
    if (store.getters.queryParametars.get('clientType') === 'token'
      && store.getters.queryParametars.get('token')) {
      await rgsInit(store);
    }
    if (config.deviceId && store.getters.isTerminal) {
      window.busService.addChannel('Device', config.deviceId);
    }
    const ticketTypes = config.ui?.config?.betslip.ticketTypes || ['single', 'combo'];
    const betslipConfig = {
      betLayout: 'B',
      channel: config.applicationName,
      ticketTypes,
      rules: config.rules,
      taxes: config.taxes,
      isPossibleWinActive: true,
      isPaymentBetAllowed: true,
      isPaymentPerBetAllowed: true,
      isPaymentPerBetStrategy: true,
      isFuturePerBetAllowed: false,
      isFuturePerTicketAllowed: false,
      isTicketCancelAllowed: false,
      isTicketRebetAllowed: false,
      isAddButtonActive: false,
      minIncrement: 0.01,
      paymentChips,
    };
    await store.dispatch('gamesBetslip/setConfig', betslipConfig);
    isReady = true;
  } catch (e) {
    console.log(e);
  }
  return isReady;
};

export default init;
